import React, { useRef } from 'react';
// eslint-disable-next-line jira/restricted/use-debounce
import { useDebouncedCallback } from 'use-debounce';
import PageIcon from '@atlaskit/icon/glyph/page';
import {
	CommandShortcuts,
	COMMAND_PALETTE_SECTIONS,
	COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY,
} from '@atlassian/jira-command-palette-common';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { SearchField } from '@atlassian/jira-searchfield';
import { useShortcutAnalytics } from '@atlassian/jira-software-keyboard-shortcuts';
import { DEBOUNCE_MILLISECONDS } from '../../../common/constants';
import { useTableFilterStore } from '../../../controllers/top-filter';
import messages from './messages';

export const TextFilter = () => {
	const searchInputRef = useRef<HTMLInputElement>(null);
	const [{ text: debouncedText }, { setTextFilter }] = useTableFilterStore();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const getCallback = (value: string) => {
		fireUIAnalytics(
			createAnalyticsEvent({
				action: 'searched',
				actionSubject: 'deploymentsTextFilter',
			}),
		);
		setTextFilter(value.trim());
	};

	const [onChangeDebounced] = useDebouncedCallback(getCallback, DEBOUNCE_MILLISECONDS);
	const fireShortcutAnalytics = useShortcutAnalytics('deployments');
	const focusSearchInput = () => {
		if (searchInputRef?.current != null) {
			requestAnimationFrame(() => {
				searchInputRef.current && searchInputRef.current.focus();
			});
			const analyticsPayload = {
				id: 'focusSearchField',
				key: 'f',
				attributes: {},
			};
			fireShortcutAnalytics(analyticsPayload);
		}
	};
	const { formatMessage } = useIntl();

	// We have to pass the `value` prop here because the store state could be modified from
	// elsewhere in the app. `SearchField` maintains its own internal state (which updates as
	// the user types), and it syncs in the `value` prop when it changes.
	return (
		<>
			<CommandShortcuts
				keyMap={{
					f: {
						callback: focusSearchInput,
						registerInCommandPalette: {
							id: 'deployments-focus-search-input',
							name: formatMessage(messages.searchCurrentPage),
							priority: COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY.searchOnCurrentPage,
							section: COMMAND_PALETTE_SECTIONS.quickActions,
							components: {
								LeftIcon: () => <PageIcon label={formatMessage(messages.searchCurrentPage)} />,
							},
							analytics: {
								action: 'searchCurrentPage',
							},
						},
					},
				}}
				location="deployments.keyboard-shortcuts"
			/>
			<SearchField
				value={debouncedText}
				// @ts-expect-error - TS2322 - Type '{ value: string; width: string; isAutocompleteDisabled: true; onChange: (value: string) => void; }' is not assignable to type 'IntrinsicAttributes & Props'.
				width="small"
				isAutocompleteDisabled
				onChange={onChangeDebounced}
				inputRef={searchInputRef}
			/>
		</>
	);
};
export default TextFilter;
